import { useTranslation } from 'react-i18next';
import { Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import EmployeeQuestionnaireSettingsTableRowActions from './employee-questionnaire-settings-table-row-actions.component';

import { IEmployeeQuestionnaireSettingsTableProps } from './employee-questionnaire-settings-tableinterfaces';

const EmployeeQuestionnaireSettingsTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  onTableChange,
  loading,
}: IEmployeeQuestionnaireSettingsTableProps) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      t={t}
    >
      <Table.Column
        title={t('settings:employeeQuestionnaire.labels.questionnaireName')}
        sorter={onTableChange}
        render={({ name }) => <Typography>{name}</Typography>}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <EmployeeQuestionnaireSettingsTableRowActions
            record={record}
            handleModals={handleModals}
            t={t}
          />
        )}
      />
    </Table>
  );
};

export default EmployeeQuestionnaireSettingsTable;
